import axios from "axios";
import { toast } from "react-toastify";

// Base instance

// 1. Create a reusable Axios client with the base URL set from .env

const client = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

// === Utility to Refresh Access Token ===
const refreshAccessToken = async () => {
  try {
    const refreshToken = localStorage.getItem("refresh_token");
    if (!refreshToken) throw new Error("No refresh token found");

    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}token/refresh/`,
      { refresh: refreshToken }
    );

    if (response.status === 200) {
      // console.log("New access token response ===>", JSON.stringify(response.data, null, 2));

      const access = response.data?.access;
      const refresh = response.data?.refresh;

      if (!access) throw new Error("No access token found in response");

      localStorage.setItem("access_token", access);
      // if (refresh) {
      //   localStorage.setItem('refresh_token', refresh);
      // }

      return access;
    } else {
      throw new Error("Unable to refresh token");
    }
  } catch (error) {
    // console.error("🔴 Refresh token failed:", error);
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    toast.error("Session has expired");
    // Optional: Redirect
    window.location.href = "/login";
    return null;
  }
};

/* 
2. REQUEST INTERCEPTOR 
   - Runs before each request.
   - You can add headers or modify the request here.
*/

client.interceptors.request.use(
  async (config) => {
    // 2.1 Attach access token from localStorage (if available)
    const token = localStorage.getItem("access_token");
    // console.log("New access token response ===>", token);

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // 2.2 Set appropriate Content-Type header

    config.headers["Content-Type"] =
      config.data instanceof FormData
        ? "multipart/form-data"
        : "application/json";

    // 2.3 Return the modified request config
    return config;
  },
  // 2.4 Return request error (if any)
  (error) => Promise.reject(error)
);

/* 
3. RESPONSE INTERCEPTOR 
   - Runs after receiving the response.
   - Handles both success and error responses.
*/

client.interceptors.response.use(
  (response) => ({
    data: response.data,
    status: response.status,
    error: null,
  }),
  async (error) => {
    const originalRequest = error.config;

    // console.log("access_token Error Response ===>", JSON.stringify(error, null, 2));

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      const newAccessToken = await refreshAccessToken();

      if (newAccessToken) {
        originalRequest.headers = {
          ...originalRequest.headers,
          Authorization: `Bearer ${newAccessToken}`,
        };
        return axios(originalRequest); // Retry with new token using base axios
      }
    }

    // If not 401 or refresh failed
    return Promise.reject({
      data: error.response ? error.response.data : null,
      status: error.response ? error.response.status : null,
      error: error.message,
    });
  }
);

export default client;
